module.exports = __webpack_public_path__ + "img/img-intro2.0d7005eb.jpg";